/**
 * RettVerk 1.2.1 - Service Worker Registration
 * Håndterer registrering og versjonsjekk av Service Worker
 * 
 * Optimalisert:
 * - Enklere versjonsjekk
 * - Færre console.warn (kun kritiske)
 * - Raskere oppdatering
 */

// App versjon fra package.json
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.2.1';

/**
 * Register service worker
 */
export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return null;
  
  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
      scope: '/'
    });
    
    // Sjekk versjon hvis SW er aktiv
    if (registration.active) {
      registration.active.postMessage({ type: 'VERSION_CHECK', version: APP_VERSION });
    }
    
    // Lytt etter oppdateringer
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      newWorker?.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          console.warn('[SW] Ny versjon tilgjengelig');
        }
      });
    });
    
    return registration;
  } catch (err) {
    console.warn('[SW] Registrering feilet:', err.message);
    return null;
  }
};

/**
 * Force update service worker
 */
export const forceUpdateServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return false;
  
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    
    await reg.update();
    reg.waiting?.postMessage({ type: 'SKIP_WAITING' });
    return true;
  } catch {
    return false;
  }
};

/**
 * Unregister all service workers
 */
export const unregisterServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return false;
  
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map(r => r.unregister()));
    return true;
  } catch {
    return false;
  }
};

export default {
  registerServiceWorker,
  forceUpdateServiceWorker,
  unregisterServiceWorker,
  APP_VERSION
};
